import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {
    SensorsComponent, UserFinesComponent, UserPaymentsComponent,
    HotelDetailsComponent, LoginHotelComponent, ParkingAddComponent,
    VehicleChecksComponent
} from './components';

import { DashboardComponent } from './components/dashboard/dashboard.component';
import { UsersComponent } from './components/users/users.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { FinesComponent } from './components/fines/fines.component';
import { ParkingLotsComponent } from './components/parking-lots/parking-lots.component';
import { InstitutionsComponent } from './components/institutions/institutions.component';
import { TownHallsPoliceComponent } from './components/town-halls-police/town-halls-police.component';
import { SupervisorsComponent } from './components/supervisors/supervisors.component';
import { AddLotComponent } from './components/add-lot/add-lot.component';
import { LoginComponent } from './components/login/login.component';
import { UserComponent } from './components/user/user.component';
import { SupervisorAddComponent } from './components/supervisor-add/supervisor-add.component';
import { SupervisorComponent } from './components/supervisor/supervisor.component';
import { AddInstitutionsComponent } from './components/add-institutions/add-institutions.component';
import { AddTownhallComponent } from './components/add-townhall/add-townhall.component';
import { SettingsListComponent } from './components/settings-list/settings-list.component';
import { ProductAddComponent } from './components/product-add/product-add.component';
import { ProductsComponent } from './components/products/products.component';
import { SensorHistoryComponent } from './components/sensor-history/sensor-history.component';
import { ParkingLotDetailComponent } from './components/parking-lot-detail/parking-lot-detail.component';
import { FineDetailsComponent } from './components/fine-details/fine-details.component';
import { SupervisorCheckedCarsComponent } from './components/supervisor-checked-cars/supervisor-checked-cars.component';
import { SupervisorFinesComponent } from './components/supervisor-fines/supervisor-fines.component';
import { HotelsComponent } from './components/hotels/hotels.component';
import { HotelAddComponent } from './components/hotel-add/hotel-add.component';

import { ParkingResolverService } from './service/main/parking-resolver.service';
import { FineResolverService } from './service/main/fine-resolver.service';
import { SensorHistoryResolverService } from './service/main/sensor-history-resolver.service';
import { SupervisorResolverService } from './service/main/supervisor-resolver.service';
import { UserResolveService } from './service/main/user-resolve.service';
import {
    HotelResolverService,
    LoginGuardService,
} from './service';

import { RoleGuardService } from './shared/services/role-guard.service';
import { VehicleCheckDetailsComponent } from './components/vehicle-check-details/vehicle-check-details.component';
import { VehicleCheckResolverService } from './service/main/vehicle-check-resolver.service';
import { FindUserComponent } from './components/find-user/find-user.component';

export const router: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [LoginGuardService]
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        },
    },
    {
        path: 'parking-lots',
        component: ParkingLotsComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        },
    },
    {
        path: 'parking-lots/add-lot',
        component: AddLotComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        },
    },
    {
        path: 'parking-lots/:id',
        component: ParkingLotDetailComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        },
        resolve: {
            parking: ParkingResolverService
        }
    },
    {
        path: 'parking-lots/edit/:id',
        component: AddLotComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        },
        resolve: {
            parking: ParkingResolverService
        }
    },
    {
        path: 'products',
        component: ProductsComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        }
    },
    {
        path: 'products/add-product',
        component: ProductAddComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        }
    },
    {
        path: 'payments',
        component: PaymentsComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'Police', 'SuperAdministrator']
        }
    },
    {
        path: 'users',
        component: UsersComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        }
    },
    {
        path: 'finduser',
        component: FindUserComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        }
    },
    {
        path: 'users/:id',
        component: UserComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        },
        resolve: {
            user: UserResolveService
        }
    },
    {
        path: 'users/fines/po',
        component: UserFinesComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        }
    },
    {
        path: 'users/payments/po',
        component: UserPaymentsComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        }
    },
    {
        path: 'fines',
        component: FinesComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'Police', 'SuperAdministrator']
        }
    },
    {
        path: 'fines/:id',
        component: FineDetailsComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'Police', 'SuperAdministrator']
        },
        resolve: {
            fine: FineResolverService
        }
    },
    {
        path: 'sensor-history/:id',
        component: SensorHistoryComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        },
        resolve: {
            id: SensorHistoryResolverService
        }
    },
    {
        path: 'parking-lots/edit/:id',
        component: AddLotComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        },
        resolve: {
            parking: ParkingResolverService
        }
    },
    {
        path: 'vehicle-exceptions',
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['SuperAdministrator']
        },
        loadChildren: './vehicle-exceptions/vehicle-exceptions.module#VehicleExceptionsModule'
    },
    {
        path: 'vehicle-checks',
        component: VehicleChecksComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'Police', 'SuperAdministrator']
        }
    },
    {
        path: 'vehicle-checks/:id',
        component: VehicleCheckDetailsComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'Police', 'SuperAdministrator']
        },
        resolve: {
            vehicleCheck: VehicleCheckResolverService
        }
    },
    {
        path: 'police',
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        },
        loadChildren: './police/police.module#PoliceModule'
    },

    {
        path: 'eve',
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator', 'Police', 'EveHandler']
        },
        loadChildren: './electric-vehicles/eve.module#ElectricVehicleExceptionModule'
    },

    {
        path: 'subscriptions',
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator', 'Police']
        },
        loadChildren: './subscriptions/subscriptions.module#SubscriptionsModule'
    },

    {
        path: 'free-parkings',
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator', 'Police']
        },
        loadChildren: './free-parkings/free-parkings.module#FreeParkingsModule'
    },

    {
        path: 'sensors',
        component: SensorsComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        }
    },
    {
        path: 'supervisors',
        component: SupervisorsComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'Police', 'SuperAdministrator']
        }
    },
    {
        path: 'supervisors/add-supervisor',
        component: SupervisorAddComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'Police', 'SuperAdministrator']
        }
    },
    {
        path: 'supervisors/:id',
        component: SupervisorComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'Police', 'SuperAdministrator']
        },
        resolve: {
            supervisor: SupervisorResolverService
        }
    },
    {
        path: 'supervisors/checked-vehicles/po',
        component: SupervisorCheckedCarsComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'Police', 'SuperAdministrator']
        }
    },
    {
        path: 'supervisors/fines/po',
        component: SupervisorFinesComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'Police', 'SuperAdministrator']
        }
    },
    {
        path: 'hotels',
        component: HotelsComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        }
    },
    {
        path: 'hotels/add-hotel',
        component: HotelAddComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        }
    },
    {
        path: 'hotels/:id',
        component: HotelDetailsComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        },
        resolve: {
            hotel: HotelResolverService
        }
    },
    {
        path: '**',
        component: DashboardComponent,
        canActivate: [RoleGuardService],
        data: {
            expectedRoles: ['Administrator', 'SuperAdministrator']
        }
    }
];

export const routes: ModuleWithProviders = RouterModule.forRoot(router, { useHash: true });
